import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M72.5421 245.379C72.5421 256.353 81.4945 263.284 91.3132 263.284C98.5329 263.284 105.175 259.529 109.218 252.021L152.247 172.316C161.488 155.567 166.686 140.55 166.686 123.8C166.686 85.3917 138.674 62 100.843 62C63.5898 62 35 85.3917 35 124.955C35 160.765 60.1244 183.868 91.3132 183.868C96.5114 183.868 101.71 183.001 103.731 181.846L104.309 182.135L75.7188 233.828C73.4085 237.871 72.5421 241.625 72.5421 245.379ZM100.843 150.657C85.2487 150.657 74.8524 139.395 74.8524 123.511C74.8524 107.339 85.2487 96.0767 100.843 96.0767C116.438 96.0767 126.834 107.339 126.834 123.511C126.834 139.395 116.438 150.657 100.843 150.657Z",
      fill: "#E5E5E5"
    }, null, -1)
  ])))
}
export default { render: render }